var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.811 0.189793C15.5585 -0.0626133 15.1493 -0.0626133 14.8969 0.189793L0.189549 14.8971C-0.0628574 15.1495 -0.0628574 15.5588 0.189549 15.8112C0.315736 15.9374 0.481174 16.0005 0.64658 16.0005C0.811986 16.0005 0.977392 15.9374 1.10361 15.8111L15.811 1.10379C16.0633 0.851418 16.0633 0.442199 15.811 0.189793Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8104 14.8967L1.10306 0.189305C0.850686 -0.0631016 0.441436 -0.0631016 0.189061 0.189305C-0.0633457 0.44168 -0.0633457 0.850898 0.189061 1.1033L14.8964 15.8107C15.0226 15.9369 15.1881 16 15.3535 16C15.5189 16 15.6843 15.9369 15.8105 15.8107C16.0628 15.5583 16.0628 15.1491 15.8104 14.8967Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a13567f2f8f8388a9203752f1bea1b17.svg";
export { ForwardRef as ReactComponent };